import { useMutation, useQueryClient } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";
import { toast } from "@app/common/hooks/useToasts";
import {
  ApiSpeakerOperation,
  ApiUpdateTranscriptTurnOperation,
} from "@app/common/types";

const patchSpeaker = ({
  sessionId,
  operation,
}: {
  sessionId: string;
  operation: ApiSpeakerOperation | ApiUpdateTranscriptTurnOperation;
}) => {
  return apiClient.session.patchTranscript(sessionId, [operation]);
};

const useEditSpeakerName = ({ sessionId }: { sessionId: string }) => {
  const queryClient = useQueryClient();

  const updateSpeakerMutation = useMutation({
    mutationFn: ({
      operation,
    }: {
      operation: ApiSpeakerOperation | ApiUpdateTranscriptTurnOperation;
    }) => patchSpeaker({ sessionId, operation }),
    onError: () => {
      toast.error({
        type: "system",
        title: "Error saving changes",
        message:
          "Read was unable able to save your recent changes. Please try again.",
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["transcript", sessionId] });
    },
  });

  return {
    updateSpeaker: updateSpeakerMutation,
  };
};

export default useEditSpeakerName;
